// Bookmarklet source. Runs in the context of x.com. X's CSP blocks any
// cross-origin fetch, so we can't hit bluebirdie.win directly. Instead we
// scrape locally, open a tab to our domain with the payload in the URL
// fragment, the ingest page posts from our own origin + postMessages the
// result back, and we close the tab so the user never leaves x.com.

export interface BookmarkletArgs {
  apiBase: string
}

const SOURCE = /* js */ `(function(){
  var A="__API__", ORIGIN=A.replace(/\\/$/,"");
  function S(el,sel){var r=el.querySelector(sel);return r?r.innerText.trim():""}
  function pick(a){
    var txt=S(a,'[data-testid="tweetText"]');
    if(!txt)return null;
    var link=a.querySelector('a[href*="/status/"] time');
    var href=link&&link.parentElement?link.parentElement.getAttribute("href"):"";
    var m=href&&href.match(/\\/([^\\/]+)\\/status\\/(\\d+)/);
    if(!m)return null;
    return {tweetUrl:"https://x.com"+href,tweetText:txt.slice(0,1000),authorHandle:m[1]};
  }
  function toast(msg, ok, link){
    var d=document.createElement("div");
    d.style.cssText="position:fixed;z-index:2147483647;right:20px;bottom:20px;max-width:320px;background:"+(ok?"#0c7dc7":"#b91c1c")+";color:white;padding:10px 14px;border-radius:8px;font:500 14px/1.3 system-ui;box-shadow:0 6px 24px rgba(0,0,0,.3);display:flex;align-items:center;gap:10px";
    var s=document.createElement("span");s.textContent=msg;d.appendChild(s);
    if(link){var a=document.createElement("a");a.href=link;a.target="_blank";a.rel="noopener";a.textContent="view";a.style.cssText="color:white;text-decoration:underline;font-weight:600";d.appendChild(a)}
    var x=document.createElement("span");x.textContent="×";x.style.cssText="cursor:pointer;opacity:.7;margin-left:auto;padding:0 4px";x.onclick=function(){d.remove()};d.appendChild(x);
    document.body.appendChild(d);
    setTimeout(function(){d.remove()},12000);
    return d;
  }
  try{
    var U=location.href,
        kind=/\\/[^\\/?#]+\\/status\\/\\d+/.test(location.pathname)?"tweet":
             /^\\/home/.test(location.pathname)?"home":
             /^\\/search/.test(location.pathname)?"search":
             /^\\/i\\/lists\\//.test(location.pathname)?"list":
             /^\\/i\\/bookmarks/.test(location.pathname)?"bookmarks":
             /^\\/[^\\/]+$/.test(location.pathname)?"profile":"other";
    var arts=[].slice.call(document.querySelectorAll('article[data-testid="tweet"]'));
    var tw=arts.map(pick).filter(Boolean);
    var seen={}, uniq=[];
    for(var i=0;i<tw.length;i++){if(!seen[tw[i].tweetUrl]){seen[tw[i].tweetUrl]=1;uniq.push(tw[i])}}
    if(uniq.length===0){toast("Scroll to show tweets, then try again",0);return}
    if(uniq.length>50)uniq=uniq.slice(0,50);
    var payload={source:{url:U,kind:kind},tweets:uniq};
    var json=JSON.stringify(payload);
    var b64=btoa(unescape(encodeURIComponent(json))).replace(/\\+/g,"-").replace(/\\//g,"_").replace(/=+$/,"");
    var pending=toast("Sending "+uniq.length+" tweets to Bluebird…",1);
    var handler=function(ev){
      if(ev.origin!==ORIGIN)return;
      var d=ev.data;
      if(!d||d.bluebird!==true)return;
      window.removeEventListener("message",handler);
      if(pending)pending.remove();
      if(d.ok){
        toast("Sent "+d.count+" tweets to Bluebird",1,ORIGIN+"/app/engagement?batch="+encodeURIComponent(d.batchId));
      }else{
        toast("Bluebird: "+(d.error||"ingest failed"),0);
      }
      try{if(w&&!w.closed)w.close()}catch(e){}
    };
    window.addEventListener("message",handler);
    var w=window.open(A+"/app/bookmarklet/ingest#"+b64,"_blank");
    setTimeout(function(){
      window.removeEventListener("message",handler);
    },30000);
  }catch(e){toast("Error: "+(e&&e.message||e),0)}
})();`

export function buildBookmarklet({ apiBase }: BookmarkletArgs): string {
  const filled = SOURCE.replace(/__API__/g, apiBase.replace(/\/$/, ''))
  const minified = filled
    .replace(/\n\s*/g, '')
    .replace(/\s{2,}/g, ' ')
  return `javascript:${encodeURIComponent(minified)}`
}
